import type { ReactNode } from 'react';

/** App frame: skip link, banner header (title + controls), main landmark,
 *  contentinfo footer. Pure layout — no data logic. */
export function AppShell({
  title,
  subtitle,
  controls,
  children,
  footer,
}: {
  title: string;
  subtitle?: string;
  controls?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <>
      <a className="skip-link" href="#main">
        Skip to results
      </a>
      <div className="app">
        <header className="app-header" role="banner">
          <div className="app-header__titles">
            <h1 className="app-header__title">{title}</h1>
            {subtitle ? <p className="app-header__subtitle">{subtitle}</p> : null}
          </div>
          {controls ? <div className="app-header__controls">{controls}</div> : null}
        </header>
        <main id="main" className="app-main" tabIndex={-1}>
          {children}
        </main>
        {footer ? (
          <footer className="app-footer" role="contentinfo">
            {footer}
          </footer>
        ) : null}
      </div>
    </>
  );
}
